// This file contains literals and constants used in code.
// For translated static content, see `content,js`

// API
export const API_BASE_PATH = '/api/v3';

// Routes
export const BASE_PATH = '/covid-19';
export const FINANCIAL_RELIEF_PATH = BASE_PATH + '/financial-relief';
export const COUNTRY_PATH = FINANCIAL_RELIEF_PATH + '/:country';
export const REGION_PATH = COUNTRY_PATH + '/:region';

// Google Analytics Stuff
export const GA_DEFAULT_CATEGORY = 'covid-19';

export const COUNTRIES_FOR_SELECT_FIELD = [
    { value: 'argentina', display: 'Argentina' },
    { value: 'australia', display: 'Australia' },
    { value: 'austria', display: 'Austria' },
    { value: 'belgium', display: 'Belgium' },
    { value: 'brazil', display: 'Brazil' },
    { value: 'canada', display: 'Canada' },
    { value: 'china', display: 'China' },
    { value: 'denmark', display: 'Denmark' },
    { value: 'france', display: 'France' },
    { value: 'germany', display: 'Germany' },
    { value: 'hong-kong', display: 'Hong Kong' },
    { value: 'india', display: 'India' },
    { value: 'ireland', display: 'Ireland' },
    { value: 'italy', display: 'Italy' },
    { value: 'japan', display: 'Japan' },
    { value: 'netherlands', display: 'Netherlands' },
    { value: 'new-zealand', display: 'New Zealand' },
    { value: 'norway', display: 'Norway' },
    { value: 'saudi-arabia', display: 'Saudi Arabia' },
    { value: 'scotland', display: 'Scotland' },
    { value: 'singapore', display: 'Singapore' },
    { value: 'south-korea', display: 'South Korea' },
    { value: 'spain', display: 'Spain' },
    { value: 'sweden', display: 'Sweden' },
    { value: 'switzerland', display: 'Switzerland' },
    { value: 'thailand', display: 'Thailand' },
    { value: 'united-kingdom', display: 'United Kingdom' },
    { value: 'united-states', display: 'United States' },
    { value: 'wales', display: 'Wales' },
];

export const AU_STATES_FOR_SELECT_FIELD = [
    { value: 'queensland', display: 'Queensland' },
    { value: 'new-south-wales', display: 'New South Wales' },
    // { value: 'northern-territory', display: 'Northern Territory' },
    { value: 'tasmania', display: 'Tasmania' },
    { value: 'western-australia', display: 'Western Australia' },
];

export const US_STATES_FOR_SELECT_FIELD = [
    { value: 'california', display: 'California' },
    { value: 'colorado', display: 'Colorado' },
    { value: 'florida', display: 'Florida' },
    { value: 'georgia', display: 'Georgia' },
    { value: 'illinois', display: 'Illinois' },
    { value: 'louisiana', display: 'Louisiana' },
    { value: 'maine', display: 'Maine' },
    { value: 'maryland', display: 'Maryland' },
    { value: 'massachussets', display: 'Massachussets' },
    { value: 'michigan', display: 'Michigan' },
    { value: 'new-mexico', display: 'New Mexico' },
    { value: 'new-york', display: 'New York' },
    { value: 'oregon', display: 'Oregon' },
    { value: 'pennsylvania', display: 'Pennsylvania' },
    { value: 'utah', display: 'Utah' },
    { value: 'washington', display: 'Washington' },
    { value: 'wisconsin', display: 'Wisconsin' },
];
